var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jackpot-wrapper", class: { "is-mobile": _vm.isMobile } },
    [
      _c(
        "div",
        { staticClass: "toggle-btns", class: { "is-mobile": _vm.isMobile } },
        [
          _c(
            "div",
            {
              class: { active: _vm.activeContent === "current" },
              on: {
                click: function ($event) {
                  return _vm.toggleActiveContent("current")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("Current jackpot")) + " ")]
          ),
          _c(
            "div",
            {
              class: { active: _vm.activeContent === "past" },
              on: {
                click: function ($event) {
                  return _vm.toggleActiveContent("past")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("Past winner")) + " ")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "jackpot-scroll-body",
          class: { "is-mobile": _vm.isMobile },
        },
        [
          _c(
            "div",
            {
              staticClass: "jackpot-info",
              class: { "is-mobile": _vm.isMobile },
            },
            [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _vm.activeContent === "current"
                    ? [
                        _c("Badge", {
                          attrs: { badgeType: "major", width: 140 },
                          scopedSlots: _vm._u(
                            [
                              !_vm.withCommission
                                ? {
                                    key: "main",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.currencySymbol) +
                                            " " +
                                            _vm._s(
                                              _vm.formatAmountWithKM(
                                                Math.floor(
                                                  Number(
                                                    _vm.majorTicket
                                                      .jackpotAmount
                                                  )
                                                ),
                                                0
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : {
                                    key: "main",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("Win")) + " "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                              {
                                key: "type",
                                fn: function () {
                                  return [_vm._v(" major ")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("Badge", {
                          attrs: { badgeType: "minor", width: 120, height: 44 },
                          scopedSlots: _vm._u(
                            [
                              !_vm.withCommission
                                ? {
                                    key: "main",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.currencySymbol) +
                                            " " +
                                            _vm._s(
                                              _vm.formatAmountWithKM(
                                                Math.floor(
                                                  Number(
                                                    _vm.minorTicket
                                                      .jackpotAmount
                                                  )
                                                ),
                                                0
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : {
                                    key: "main",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("Win")) + " "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                              {
                                key: "type",
                                fn: function () {
                                  return [_vm._v(" minor ")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("Badge", {
                          attrs: { badgeType: "mini", width: 100, height: 38 },
                          scopedSlots: _vm._u(
                            [
                              !_vm.withCommission
                                ? {
                                    key: "main",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.currencySymbol) +
                                            " " +
                                            _vm._s(
                                              _vm.formatAmountWithKM(
                                                Math.floor(
                                                  Number(
                                                    _vm.miniTicket.jackpotAmount
                                                  )
                                                ),
                                                0
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : {
                                    key: "main",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("Win")) + " "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                              {
                                key: "type",
                                fn: function () {
                                  return [_vm._v(" mini ")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    : [
                        _c("div", { staticClass: "my-tickets" }, [
                          _c("div", { staticClass: "header" }, [
                            _vm._v(_vm._s(_vm.$t("My tickets"))),
                          ]),
                          _c("div", { staticClass: "major-tickets tickets" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/major-ticket.webp"),
                              },
                            }),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                " x" +
                                  _vm._s(_vm.ownerPastMajorTicketsCount) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "minor-tickets tickets" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/minor-ticket.webp"),
                              },
                            }),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                " x" +
                                  _vm._s(_vm.ownerPastMinorTicketsCount) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "mini-tickets tickets" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/mini-ticket.webp"),
                              },
                            }),
                            _c("span", { staticClass: "text" }, [
                              _vm._v(
                                " x" +
                                  _vm._s(_vm.ownerPastMiniTicketsCount) +
                                  " "
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "right",
                  class: { past: _vm.activeContent === "past" },
                },
                [
                  _c("div", { staticClass: "super-draw-no" }, [
                    _c("div", { staticClass: "supper-draw-info" }, [
                      _c("div", { staticClass: "super-draw-label" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.$capitalize(_vm.currentLuckyDraw.name, true)
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "super-draw-number" }, [
                        _vm._v(
                          " No. " +
                            _vm._s(
                              _vm.activeContent === "past"
                                ? _vm.currentLuckyDraw.drawNum - 1
                                : _vm.currentLuckyDraw.drawNum
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "super-draw-img" }, [
                      _vm.activeContent === "current"
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/images/super-draw.webp"),
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/assets/images/super-draw-past.webp"),
                            },
                          }),
                    ]),
                  ]),
                  _vm.activeContent === "current"
                    ? _c("CountdownWrapper", {
                        attrs: {
                          timerHour: _vm.timerHour,
                          timerMinite: _vm.timerMinite,
                          timerSecond: _vm.timerSecond,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "record" }, [
            _c(
              "div",
              { staticClass: "header" },
              [
                _vm.activeContent === "current"
                  ? [
                      _c("div", { staticClass: "left" }, [
                        _vm._v(" " + _vm._s(_vm.$t("My tickets")) + " "),
                      ]),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "major-tickets tickets" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/major-ticket.webp"),
                            },
                          }),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              " x" +
                                _vm._s(_vm.ownerCurrentMajorTicketsCount) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "minor-tickets tickets" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/minor-ticket.webp"),
                            },
                          }),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              " x" +
                                _vm._s(_vm.ownerCurrentMinorTicketsCount) +
                                " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "mini-tickets tickets" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/mini-ticket.webp"),
                            },
                          }),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              " x" +
                                _vm._s(_vm.ownerCurrentMiniTicketsCount) +
                                " "
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  : [_vm._v(_vm._s(_vm.$t("Winners")))],
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "body" },
              [
                _vm.activeContent === "current"
                  ? [
                      _c("div", { staticClass: "progress-to-next" }, [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(_vm._s(_vm.$t("Progress"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "progress-bar-wrapper" },
                          [
                            _c("progress-bar", {
                              attrs: {
                                diameter: 200,
                                "completed-steps": _vm.progressVal,
                                "total-steps": 100,
                                innerStrokeColor: "#d9d8d8",
                                startColor: "#f9cf6b",
                                stopColor: "#f9cf6b",
                                showTip: false,
                                height: 4,
                                animateSpeed: 1000,
                              },
                            }),
                            _vm.progressVal > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "progress-milestone-coin zero",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/coin.webp"),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm.progressVal > 25
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "progress-milestone-coin one",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/coin.webp"),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm.progressVal > 50
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "progress-milestone-coin two",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/coin.webp"),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm.progressVal > 75
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "progress-milestone-coin three",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/coin.webp"),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "amount-track" }, [
                          _vm._v(
                            _vm._s(_vm.currentAmount) +
                              " / " +
                              _vm._s(_vm.nextTicketAmount)
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "ticket-logs",
                          class: { landscape: _vm.isMobileLandscape },
                        },
                        [
                          _c("JackpotLogs", {
                            attrs: {
                              logTickets: _vm.ownerCurrentTicketsLog,
                              ticketsLength:
                                _vm.ownerCurrentTicketsLog.length || 0,
                            },
                            on: { loadMoreTickets: _vm.loadMoreTickets },
                          }),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass: "winner-logs",
                          class: { landscape: _vm.isMobileLandscape },
                        },
                        [
                          _c("div", { staticClass: "major winner-row" }, [
                            _c(
                              "div",
                              { staticClass: "badge" },
                              [
                                _c("Badge", {
                                  attrs: { badgeType: "major", width: 140 },
                                  scopedSlots: _vm._u(
                                    [
                                      !_vm.withCommission
                                        ? {
                                            key: "main",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.currencySymbol) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.formatAmountWithKM(
                                                        Number(
                                                          _vm.majorWinner.amount
                                                        ),
                                                        0
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        : {
                                            key: "main",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("Win")) +
                                                    " "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                      {
                                        key: "type",
                                        fn: function () {
                                          return [_vm._v(" major ")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "info-list" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "info",
                                  class: { isMe: _vm.majorWinner.isMe },
                                },
                                [
                                  _c("div", { staticClass: "name" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.majorWinner.isMe
                                            ? _vm.majorWinner.displayName
                                            : _vm.getWildCardName(
                                                _vm.majorWinner.displayName
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "id" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.majorWinner.sid) + " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "minor winner-row" }, [
                            _c(
                              "div",
                              { staticClass: "badge" },
                              [
                                _c("Badge", {
                                  attrs: { badgeType: "minor", width: 120 },
                                  scopedSlots: _vm._u(
                                    [
                                      !_vm.withCommission
                                        ? {
                                            key: "main",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.currencySymbol) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.formatAmountWithKM(
                                                        Number(
                                                          _vm.minorWinners[0]
                                                            .amount
                                                        ),
                                                        0
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        : {
                                            key: "main",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("Win")) +
                                                    " "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                      {
                                        key: "type",
                                        fn: function () {
                                          return [_vm._v(" minor ")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "info-list" },
                              _vm._l(_vm.minorWinners, function (minorInfo) {
                                return _c(
                                  "div",
                                  {
                                    key: minorInfo.id,
                                    staticClass: "info",
                                    class: { isMe: minorInfo.isMe },
                                  },
                                  [
                                    _c("div", { staticClass: "name" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            minorInfo.isMe
                                              ? minorInfo.displayName
                                              : _vm.getWildCardName(
                                                  minorInfo.displayName
                                                )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("div", { staticClass: "id" }, [
                                      _vm._v(" " + _vm._s(minorInfo.sid) + " "),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                          _c("div", { staticClass: "mini winner-row" }, [
                            _c(
                              "div",
                              { staticClass: "badge" },
                              [
                                _c("Badge", {
                                  attrs: { badgeType: "mini" },
                                  scopedSlots: _vm._u(
                                    [
                                      !_vm.withCommission
                                        ? {
                                            key: "main",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.currencySymbol) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.formatAmountWithKM(
                                                        Number(
                                                          _vm.miniWinners[0]
                                                            .amount
                                                        ),
                                                        0
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        : {
                                            key: "main",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("Win")) +
                                                    " "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                      {
                                        key: "type",
                                        fn: function () {
                                          return [_vm._v(" mini ")]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "info-list" },
                              _vm._l(_vm.miniWinners, function (miniInfo) {
                                return _c(
                                  "div",
                                  {
                                    key: miniInfo.id,
                                    staticClass: "info",
                                    class: { isMe: miniInfo.isMe },
                                  },
                                  [
                                    _c("div", { staticClass: "name" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            miniInfo.isMe
                                              ? miniInfo.displayName
                                              : _vm.getWildCardName(
                                                  miniInfo.displayName
                                                )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("div", { staticClass: "id" }, [
                                      _vm._v(" " + _vm._s(miniInfo.sid) + " "),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ],
              ],
              2
            ),
          ]),
        ]
      ),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }